/**
 * После OIDC-callback backend кладёт пару в in-memory slot и
 * выставляет httpOnly cookie sd_sso_handoff с его ID. Фронт зовёт
 * GET /api/v1/auth/sso/handoff (cookie летит автоматически), получает
 * access+refresh, кладёт в localStorage и делает полный reload.
 *
 * Раньше токены передавались через URL query, но Safari ITP режет query
 * при cross-origin redirect, поэтому переехали на cookie+handoff.
 */
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader2, AlertTriangle } from 'lucide-react';
import axios from 'axios';

const STORAGE_KEY = 'sd.auth';

export default function SsoFinishPage() {
  const [sp] = useSearchParams();
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    const returnTo = sp.get('return_to') || '/';
    (async () => {
      try {
        const r = await axios.get('/api/v1/auth/sso/handoff', {
          withCredentials: true,
        });
        const { access_token, refresh_token } = r.data || {};
        if (!access_token) {
          setErr('handoff не вернул access_token');
          return;
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          token: access_token,
          refresh_token: refresh_token || undefined,
        }));
        // Полный reload, чтобы AuthProvider с нуля прочитал localStorage.
        window.location.replace(returnTo);
      } catch (e: any) {
        const detail = e?.response?.data?.detail || e?.message || 'неизвестная ошибка';
        // eslint-disable-next-line no-console
        console.error('[sso-finish] handoff failed:', detail, e);
        setErr(`Не удалось завершить SSO: ${detail}`);
        setTimeout(() => {
          window.location.replace('/login?sso_error=' + encodeURIComponent(detail));
        }, 3000);
      }
    })();
  }, [sp]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center text-slate-300 px-4">
      {err ? (
        <div className="max-w-md bg-red-900/30 border border-red-800 rounded-xl p-6 text-center">
          <AlertTriangle className="text-red-400 mx-auto mb-3" size={28} />
          <h2 className="text-lg font-bold text-white mb-2">SSO не завершён</h2>
          <p className="text-red-200 text-sm">{err}</p>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-sm">
          <Loader2 className="animate-spin" size={16} /> Завершение входа через SSO…
        </div>
      )}
    </div>
  );
}
